/** An order's Drive folder, named by its kind and the platform id it belongs to — never by a Drive id. */
export type DriveFolderRef =
  | { kind: 'order' }
  | { kind: 'drop' }
  | { kind: 'booking'; bookingId: string }
  | { kind: 'decoration'; operationId: string };

export type DriveRole = 'WRITER' | 'READER' | 'OTHER';

export type DriveAccessSide = 'ADVERTISER' | 'MALL' | 'PRINTER' | 'STAFF' | 'MANUAL';

export type PreviewGenerationMode = 'PER_FILE' | 'COMBINED';

export const MAX_PREVIEW_SOURCES = 12;

const EMAIL = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

/** The path segment under `/orders/{orderId}/drive/folders/` that names [folder]. */
export const driveFolderPath = (folder: DriveFolderRef): string => {
  switch (folder.kind) {
    case 'booking':
      return `booking/${encodeURIComponent(folder.bookingId)}`;
    case 'decoration':
      return `decoration/${encodeURIComponent(folder.operationId)}`;
    default:
      return folder.kind;
  }
};

/** Uploads land only in the drop or a live decoration; a booking or the order itself only lists. */
export const acceptsUploads = (folder: DriveFolderRef): boolean =>
  folder.kind === 'drop' || folder.kind === 'decoration';

/**
 * The role a hand share takes on [folder]: a Contributor on the drop, where an outside party delivers; a Viewer on a
 * booking or decoration folder. The order folder itself is never shared by hand.
 */
export const shareRoleFor = (folder: DriveFolderRef): DriveRole | undefined => {
  if (folder.kind === 'drop') return 'WRITER';
  if (folder.kind === 'booking' || folder.kind === 'decoration') return 'READER';

  return undefined;
};

/** Whether [email], once trimmed, reads as an address a folder or a plan can be shared with. */
export const isShareableEmail = (email: string): boolean => EMAIL.test(email.trim());
